export enum LongFloatStitchingMethod {
  MIDDLE = 'MIDDLE',
  BORDER = 'BORDER',
  RANDOM = 'RANDOM'
}
